import {PropsWithChildren, useEffect, useRef, useState} from "react";
import {SimpleIconButton} from "../../../misc/lists/SimpleIconButton";
import {Popover} from "../../../misc/Popover";

export function IconPopupItem(props: PropsWithChildren<{
    icon: any;
    open?: boolean;
    onOpen?(tf: boolean): void;
}>) {
    const [anchorEl, setAnchorEl] = useState<any>();

    const lastFocus = useRef<number>(0);
    const popFocused = useRef(false);

    const controlled = props.open !== undefined;

    useEffect(() => {
        if(!anchorEl) return;
        if(controlled) return;

        const int = setInterval(() => {
            if(!anchorEl) return;
            if(popFocused.current) return;

            if(Date.now() - lastFocus.current > 200) {
                setAnchorEl(null);
            }
        }, 100);

        return () => clearInterval(int)
    }, [anchorEl, controlled]);

    const open = props.open !== undefined ? props.open : !!anchorEl;

    return (
        <>
            <SimpleIconButton
                onMouseEnter={(e: any) => {
                    setAnchorEl(e.target as any);
                    if(props.onOpen) props.onOpen(true);
                }}
            >
                {props.icon}
            </SimpleIconButton>

            {anchorEl && open && <Popover
                anchorOrigin={{ /* overlap to make mouse event easier */
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                anchorEl={anchorEl} open
                onClose={() => {
                    if(props.onOpen) {
                        props.onOpen(false)
                    } else {
                        setAnchorEl(null)
                    }
                }}
                ref={r => {
                    if(!r) return;

                    setTimeout(() => {
                        // trigger window resize event to re-center
                        const ev = new Event("resize");
                        window.dispatchEvent(ev);
                    }, 500)
                }}
            >
                <div
                    onMouseOver={() => {
                        popFocused.current = true;
                    }}
                    onMouseOut={() => {
                        popFocused.current = false;
                        lastFocus.current = Date.now();
                    }}
                    style={{paddingTop: 8, paddingBottom: 8, maxHeight: window.innerHeight * 0.8, overflowY: "auto"}}
                >
                    {props.children}
                </div>
            </Popover>}
        </>
    )
}